(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  L.Control.MfMarker = (function(superClass) {
    extend(MfMarker, superClass);

    function MfMarker() {
      this._pointSelected = bind(this._pointSelected, this);
      this.select = bind(this.select, this);
      this.deselect = bind(this.deselect, this);
      this.drawMarker = bind(this.drawMarker, this);
      this.handleMarkerDrop = bind(this.handleMarkerDrop, this);
      this.setStealthStyling = bind(this.setStealthStyling, this);
      this.setDefaults = bind(this.setDefaults, this);
      this.setColor = bind(this.setColor, this);
      MfMarker.__super__.constructor.call(this);
      this.setDefaults();
    }

    MfMarker.prototype.setColor = function(color) {
      return this.color = color;
    };

    MfMarker.prototype.setDefaults = function() {
      return this.options = {
        position: 'topleft',
        draw: {
          style: {
            color: '#008161',
            width: 3
          }
        },
        finished: {
          style: {
            'fillOpacity': 0.6,
            'weight': 2,
            'color': '#0F0'
          }
        },
        colors: {
          style: (function(_this) {
            return function(mode) {
              return {
                color: '#008000',
                width: 3
              };
            };
          })(this)
        },
        toolbars: [
          {
            style: {
              width: '30x',
              height: '30px'
            },
            rows: [
              [
                {
                  name: 'draw-marker',
                  html: '<i class="fas fa-pencil-alt"></i>',
                  toggle: true
                }
              ]
            ]
          }
        ]
      };
    };

    MfMarker.prototype.setStealthStyling = function() {
      return this.options = {
        position: 'topleft',
        draw: {
          style: {
            color: '#008161',
            width: 3
          }
        },
        finished: {
          style: {
            'fillOpacity': 0.6,
            'weight': 2,
            'color': '#0F0'
          }
        },
        colors: {
          style: (function(_this) {
            return function(mode) {
              return {
                color: '#008000',
                width: 3
              };
            };
          })(this)
        },
        toolbars: [
          {
            rows: []
          }
        ]
      };
    };

    MfMarker.prototype.onAdd = function(map) {
      var container;
      if (this.map == null) {
        this.map = map;
      }
      this.mode = null;
      this.current_tool = null;
      container = MfMarker.__super__.onAdd.call(this, map);
      this.addCallback('draw-marker', this.drawMarker);
      this.map.on('draw:created', this.handleMarkerDrop);
      this.selectBtn('draw-marker');
      this.drawMarker();
      return container;
    };

    MfMarker.prototype.handleMarkerDrop = function(e) {
      this.enableBtn('draw-marker');
      this.deselectBtn('draw-marker');
      return this.fire('mfmarker:dropped', e);
    };

    MfMarker.prototype.drawMarker = function() {
      this.disableBtn('draw-marker');
      this.current_tool = new L.Draw.Marker(this.map, {
        icon: new L.mapbox.marker.icon({
          'marker-color': this.color,
          'marker-symbol': 'circle'
        }),
        draggable: true
      });
      this.current_tool.enable();
      return this.fire('mfmarker:tool_selected');
    };

    MfMarker.prototype.deselect = function() {
      return this.current_tool.disable();
    };

    MfMarker.prototype.select = function() {
      this.current_tool.enable();
      return this.fire('mfmarker:tool_selected');
    };

    MfMarker.prototype._pointSelected = function(e) {
      var handler, ref;
      handler = new L.Edit.Marker(e.layer);
      handler.enable();
      this.fire('select:point-selected');
      if (this.current_tool && (((ref = this.current_tool) != null ? ref.disable : void 0) != null)) {
        this.current_tool.disable();
      }
      return handler;
    };

    return MfMarker;

  })(L.Control.MfButtonGrid);

}).call(this);
